"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingPolicy = void 0;
// Pulled from `@prezly/sdk` to get rid of direct dependency requirement
var TrackingPolicy;
(function (TrackingPolicy) {
    TrackingPolicy["DEFAULT"] = "default";
    TrackingPolicy["DISABLED"] = "disabled";
    TrackingPolicy["CONSENT_TO_IDENTIFY"] = "consent-to-identify";
})(TrackingPolicy || (exports.TrackingPolicy = TrackingPolicy = {}));
//# sourceMappingURL=types.js.map